import { Card, Result } from "antd";
import { PageContent } from "components/UI";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const ForbiddenPage = ({ title }) => {
  const { t } = useTranslation();
  return (
    <>
      <Helmet title={title} />
      <PageContent>
        <Card>
          <Result
            status="403"
            title="403"
            subTitle={t("forbidden_page.message")}
          />
        </Card>
      </PageContent>
    </>
  );
};

export default ForbiddenPage;
